// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hk-0";